
import * as React from "react"
import * as ReactDOM from "react-dom"

type Props = {
  error: string
  close?: () => void
}

type State = {
}

declare var $: any

export default class PricingError extends React.Component<Props, State> {

  constructor(props, context) {
    super(props, context)
    this.state = {
    }
  }

  componentDidMount() {
    this.onLinkClick = this.onLinkClick.bind(this)

    $(ReactDOM.findDOMNode(this)).on('click', 'a', this.onLinkClick)
  }

  componentWillUnmount() {
    $(ReactDOM.findDOMNode(this)).off('click', 'a', this.onLinkClick)
  }

  onLinkClick() : void {
    if (this.props.close) {
      this.props.close()
    }
  }

  render() {
    return (
      <div ref="error" dangerouslySetInnerHTML={ {__html: this.props.error} } />
    )
  }
}
